import script from "./SobrePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SobrePage.vue?vue&type=script&setup=true&lang=js"

import "./SobrePage.vue?vue&type=style&index=0&id=151a2034&lang=css"

const __exports__ = script;

export default __exports__